"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Provider {
}
exports.Provider = Provider;
class Matterport extends Provider {
}
exports.Matterport = Matterport;
class InsideMaps extends Provider {
}
exports.InsideMaps = InsideMaps;
//# sourceMappingURL=unit-media.type.js.map